import { render } from "./HeroiconsSolidSpeakerphone.vue?vue&type=template&id=d48807de"
const script = {}

import exportComponent from "/Users/dorinpuscasu/Desktop/Projects/linella/linella-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidSpeakerphone.vue"]])

export default __exports__